// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Modal - Ethereal Tech Design
 *
 * Features glassmorphism modal with backdrop blur,
 * elegant entrance animation, and refined styling.
 */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(var(--blur-sm));
  -webkit-backdrop-filter: blur(var(--blur-sm));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal);
  animation: overlay-fade-in 0.3s var(--ease-out-expo);
}

@keyframes overlay-fade-in {
  from {
    opacity: 0;
    backdrop-filter: blur(0);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(var(--blur-sm));
  }
}

.modal-content {
  position: relative;
  background: var(--bg-elevated);
  backdrop-filter: blur(var(--blur-lg));
  -webkit-backdrop-filter: blur(var(--blur-lg));
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-2xl);
  padding: var(--spacing-2xl);
  box-shadow: var(--shadow-xl), 0 0 60px rgba(99, 102, 241, 0.1);
  max-height: 90vh;
  overflow-y: auto;
  animation: modal-enter 0.4s var(--ease-out-expo);
}

/* Top highlight */
.modal-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--glass-highlight), transparent);
}

@keyframes modal-enter {
  from {
    opacity: 0;
    transform: translateY(-24px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ===== Modal Sizes ===== */
.modal-sm {
  width: 90%;
  max-width: 400px;
}

.modal-md {
  width: 90%;
  max-width: 500px;
}

.modal-lg {
  width: 90%;
  max-width: 700px;
}

/* ===== Modal Scrollbar ===== */
.modal-content::-webkit-scrollbar {
  width: 6px;
}

.modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.modal-content::-webkit-scrollbar-thumb {
  background: var(--bg-tertiary);
  border-radius: var(--radius-full);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .modal-content {
    padding: var(--spacing-xl);
    margin: var(--spacing-md);
    border-radius: var(--radius-xl);
  }

  .modal-sm,
  .modal-md,
  .modal-lg {
    width: calc(100% - var(--spacing-lg));
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./../../../packages/apps/myagent/myagent_ui/src/components/Modal.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAIF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,qCAAqC;EACrC,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,6CAA6C;EAC7C,qCAAqC;EACrC,gCAAgC;EAChC,2BAA2B;EAC3B,8DAA8D;EAC9D,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oFAAoF;AACtF;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;;;IAGE,qCAAqC;IACrC,eAAe;EACjB;AACF","sourcesContent":["/**\n * Modal - Ethereal Tech Design\n *\n * Features glassmorphism modal with backdrop blur,\n * elegant entrance animation, and refined styling.\n */\n\n@import \"../styles/variables.css\";\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(var(--blur-sm));\n  -webkit-backdrop-filter: blur(var(--blur-sm));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: var(--z-modal);\n  animation: overlay-fade-in 0.3s var(--ease-out-expo);\n}\n\n@keyframes overlay-fade-in {\n  from {\n    opacity: 0;\n    backdrop-filter: blur(0);\n  }\n  to {\n    opacity: 1;\n    backdrop-filter: blur(var(--blur-sm));\n  }\n}\n\n.modal-content {\n  position: relative;\n  background: var(--bg-elevated);\n  backdrop-filter: blur(var(--blur-lg));\n  -webkit-backdrop-filter: blur(var(--blur-lg));\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-2xl);\n  padding: var(--spacing-2xl);\n  box-shadow: var(--shadow-xl), 0 0 60px rgba(99, 102, 241, 0.1);\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: modal-enter 0.4s var(--ease-out-expo);\n}\n\n/* Top highlight */\n.modal-content::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, var(--glass-highlight), transparent);\n}\n\n@keyframes modal-enter {\n  from {\n    opacity: 0;\n    transform: translateY(-24px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ===== Modal Sizes ===== */\n.modal-sm {\n  width: 90%;\n  max-width: 400px;\n}\n\n.modal-md {\n  width: 90%;\n  max-width: 500px;\n}\n\n.modal-lg {\n  width: 90%;\n  max-width: 700px;\n}\n\n/* ===== Modal Scrollbar ===== */\n.modal-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.modal-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.modal-content::-webkit-scrollbar-thumb {\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-full);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .modal-content {\n    padding: var(--spacing-xl);\n    margin: var(--spacing-md);\n    border-radius: var(--radius-xl);\n  }\n\n  .modal-sm,\n  .modal-md,\n  .modal-lg {\n    width: calc(100% - var(--spacing-lg));\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
